import { type ValidatedIql, toValidatedIql } from './types.tsx';

export const EMPTY_VALIDATED_IQL: ValidatedIql = toValidatedIql('');
